import { render } from "./completeReserComponent.vue?vue&type=template&id=6a10281d"
import script from "./completeReserComponent.vue?vue&type=script&lang=js"
export * from "./completeReserComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__